const CHAT_LIGHTBOX_SWIPE_MIN = 50;
const CHAT_LIGHTBOX_SWIPE_MS = 800;

/** Left swipe is next. Right swipe is previous. A vertical move stays put. */
function chatLightboxSwipe(
  dx,
  dy,
  {
    minDistance = CHAT_LIGHTBOX_SWIPE_MIN,
    maxDuration = CHAT_LIGHTBOX_SWIPE_MS,
    elapsed = 0,
  } = {},
) {
  const absX = Math.abs(Number(dx) || 0);
  const absY = Math.abs(Number(dy) || 0);
  if (elapsed > maxDuration || absX < minDistance || absX < absY * 1.4) {
    return null;
  }
  return dx < 0 ? 'next' : 'prev';
}

function chatLightboxIndex(index, length, direction) {
  const count = Number(length) || 0;
  if (count < 1) return 0;
  const current = Number(index);
  const start = Number.isFinite(current) ? current : 0;
  const step = direction === 'prev' ? -1 : 1;
  return (((start + step) % count) + count) % count;
}

module.exports = {
  CHAT_LIGHTBOX_SWIPE_MIN,
  chatLightboxSwipe,
  chatLightboxIndex,
};
